import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import RouteConstants from '../../constant/Routeconstant';
import { useSelector } from 'react-redux';


const LeadProtectedRoute = ({ children }) => {
  const location = useLocation();
  const leadToken = useSelector((state) => state.leads.leadData);
  const isLeadAuthenticated = !!leadToken.token;

  if (!isLeadAuthenticated) {
    return (
      <Navigate
        to={RouteConstants.NOTFOUND}
        state={{ from: location }}
        replace
      />
    );
  }

return <>{children}</>;
};

export default LeadProtectedRoute;
